import { render } from "./DialogShare.vue?vue&type=template&id=669d4e30"
import script from "./DialogShare.vue?vue&type=script&lang=js"
export * from "./DialogShare.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__